import React from 'react';

import { Stack, Divider, createStyles } from '@mantine/core';
import type { PackageUtilizationExpectationListItem } from 'types';

import Form from './Form';
import Table from './Table';

const useStyles = createStyles(() => ({
  form: {
    marginBottom: '0.5rem',
  },
}));

type EditExpectationFormProps = {
  packageExpectation: PackageUtilizationExpectationListItem;
};

const EditExpectationForm = ({ packageExpectation }: EditExpectationFormProps): JSX.Element => {
  const { classes } = useStyles();

  return (
    <Stack spacing='xs'>
      <Form className={classes.form} packageExpectation={packageExpectation} />
      <Divider my='xs' />
      <Table />
    </Stack>
  );
};

export default EditExpectationForm;
